<!-- TODO: Make sense to refactor it -->

<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<header class="main-header">
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar">
        <div id="userMenu" class="mb-0">
            <div class="d-flex justify-content-end temp-header-container">
                <ng-container *ngIf="isShowCreateServiceRequestButton && isCustomerRole">
                    <button mat-button class="btn-csr" (click)="onCreateServiceRequest()"><mat-icon>add</mat-icon>SERVICE REQUEST</button>
                </ng-container>

                <div class="timeZone align-self-center">
                    <ngx-select-dropdown
                        id="timeZoneDropDown"
                        class="time-zone-dropdown"
                        [class.cursorDisabled]="currentActivePage == 'Customer Dashboard' && user.role == 'Management'"
                        name="timeZone"
                        tabindex="0"
                        [config]="timezoneConfig"
                        [disabled]="currentActivePage == 'Customer Dashboard' && user.role == 'Management'"
                        [multiple]="false"
                        [options]="timezones"
                        [(ngModel)]="selectedTimezone"
                        (change)="selectTimezone($event)"
                        (click)="clickDropDown('timeZoneDropDown')"
                    >
                    </ngx-select-dropdown>
                </div>

                <div class="d-flex flex-header-buttons">
                    <button
                        *ngIf="isDownloadButtonShow == true"
                        mat-mini-fab
                        class="tac-fab-black downloadUI"
                        title="Download UI"
                        (click)="download()"
                    >
                        <mat-icon>download</mat-icon>
                    </button>

                    <button
                        *ngIf="!isInternalReadOnly"
                        mat-mini-fab
                        class="tac-fab-black"
                        title="Group Chat"
                        [routerLink]="['/group-chat']"
                    >
                        <mat-icon>forum</mat-icon>
                    </button>

                    <span
                        *ngIf="
                            incomingMessage != 0 &&
                            (user.role == 'Executive Admin' || user.role == 'Coordinator' || user.role == 'Management')
                        "
                        class="leg-detail-dot status-dot m-0"
                        style="position: relative; right: 13px !important; bottom: 12px !important"
                    >
                        {{ incomingMessage }}
                    </span>
                </div>
                <app-notifications *ngIf="isShowNotificationButton" class="notifications"></app-notifications>
                <div class="flex-center">
                    <div
                        [matMenuTriggerFor]="menu"
                        (menuClosed)="clickUserDropDownClose(); isUserDropDownopen = false"
                        (menuOpened)="clickUserDropDownOpen(); isUserDropDownopen = true"
                    >
                        <a
                            class="dropdown-toggle icon_profile rounded_profile_icon"
                            data-toggle="dropdown"
                            href="#"
                            style="float: right; text-decoration: none; padding: 0px"
                        >
                            <div *ngIf="!isCurrentUserPicture" class="user-initial user-logo" [class.active]="isUserDropDownopen">
                                {{ userAbbreviation }}
                            </div>
                            <img
                                *ngIf="isCurrentUserPicture"
                                class="user-logo"
                                class="img-circle headerProfileIcon"
                                [class.active]="isUserDropDownopen"
                                alt="User Image"
                                style="height: 45px; width: 45px"
                                [src]="currentUserPicture"
                            />
                        </a>
                    </div>
                    <mat-menu class="member_menu" #menu="matMenu">
                        <div class="profile_submenu">
                            <div class="user-panel">
                                <div class="user-header d-flex border-none">
                                    <div *ngIf="!isCurrentUserPicture" class="user-initial">{{ userAbbreviation }}</div>
                                    <img
                                        *ngIf="isCurrentUserPicture"
                                        class="img-circle user-image-size d-flex ml-3 align-self-center"
                                        alt="User Image"
                                        [src]="currentUserPicture"
                                    />
                                    <div class="d-flex user-info">
                                        <div class="user-name">{{ user.name }}</div>
                                        <span>Role: {{ user.role }}</span>
                                        <span>Org: {{ user.businessUnitName }}</span>
                                    </div>
                                </div>
                                <ng-container *ngIf="user && user.assignedRoleList && user.assignedRoleList.length > 1">
                                    <div class="role-block">
                                        <div class="role-block__title">My roles (click to switch)</div>
                                        <div
                                            *ngFor="let role of user.assignedRoleList"
                                            class="role-block__item"
                                            [class.active]="user.roleId == role.roleId"
                                        >
                                            <mat-radio-group>
                                                <mat-radio-button
                                                    [checked]="user.roleId === role.roleId"
                                                    [value]="role.roleId"
                                                    (change)="switchRole(role)"
                                                    >{{ role.roleName }}
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="user && user.businessUnitList && user.businessUnitList.length">
                                    <div class="role-block">
                                        <div class="role-block__title">My organization (click to switch)</div>
                                        <div
                                            *ngFor="let org of user.businessUnitList"
                                            class="role-block__item"
                                            [class.active]="user.businessUnitId == org.id"
                                        >
                                            <mat-radio-group>
                                                <mat-radio-button
                                                    [checked]="user.businessUnitId === org.id"
                                                    [value]="org.id"
                                                    (change)="switchOrganization(org)"
                                                    >{{ org.name }}
                                                </mat-radio-button>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                </ng-container>
                                <div class="user-footer">
                                    <div class="user-footer__link border">
                                        <a class="user-footer__link-text" [routerLink]="['/v2/profile']">
                                            <img alt="" src="assets/icons/v2/user.svg" />
                                            <span>View Profile</span>
                                        </a>
                                    </div>
                                    <div class="user-footer__link logout" (click)="signOut()">
                                        <img alt="" src="assets/icons/v2/logout.svg" />
                                        <span>Log out</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-menu>
                </div>
            </div>
        </div>
    </nav>
</header>

<app-header-mobile
    class="header-mobile"
    [(isMenuOpen)]="isMenuOpen"
    (isMenuOpenChange)="isMenuOpenChange.emit(isMenuOpen)"
></app-header-mobile>
